import { useState } from "react";
import { Loader2, ListPlus } from "lucide-react";

export const QuickAdd = ({ onAdd, busy }) => {
  const [text, setText] = useState("");
  const names = text.split(/[\n,]/).map((n) => n.trim()).filter(Boolean).slice(0, 40);
  const submit = async () => { await onAdd(names); setText(""); };
  return (
    <div className="space-y-2">
      <div className="text-sm font-bold">Quick-add players</div>
      <p className="text-xs text-slate-500">Type or paste names – one per line, or separated by commas. Each player gets the squad's club look – then add photos and stats with Edit.</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} placeholder={"Type names here, e.g.\nSeán Murphy\nAoife Kelly"}
        className="w-full border-2 border-slate-200 p-3 text-sm outline-none focus:border-slate-900" data-testid="squad-quick-add-textarea" />
      <button type="button" onClick={submit} disabled={!names.length || busy} data-testid="squad-quick-add-button"
        className="btn-blaze flex items-center gap-2 px-4 py-2.5 text-sm">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ListPlus className="h-4 w-4" />} Add {names.length || ""} player{names.length === 1 ? "" : "s"}
      </button>
      {!names.length && <p className="text-xs text-slate-500" data-testid="squad-quick-add-hint">Type at least one name above to enable this button.</p>}
    </div>
  );
};
